<template>
    <v-combobox
        v-model        = "selected"
        :items         = "contacts"
        item-text      = "name"
        item-value     = "id"
        class          = "mail-adress mt-0 pt-0 mb-0 pb-0"
        @change        = "onChange"
        autocomplete   = "off"
        autocorrect    = "off"
        autocapitalize = "off"
        spellcheck     = "false"
        :search-input.sync="search"
        hide-selected
        hide-details
        chips
        multiple
        clearable
        :key="refresh"
    >
        <template v-slot:prepend-inner>
            <div class="mail-label v-flex">
                {{ label }}
            </div>
        </template>


        <!-- display selected contacts -->
        <template v-slot:selection="data">
            <p-recipient-chip
                :recipient = "data.item"
                :color     = "chipColor"
                @remove    = "onRemove"
            />
        </template>
        <!-- display selected contacts -->

        <template v-slot:no-data v-if="search">
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        <div class="pl-2">
                            <span>{{ $t('mail.contact.notfound') }}<strong>{{ search }}</strong>". Mit </span>
                            <v-icon size="22">mdi-keyboard-return</v-icon>
                            <span>wird die Email Adresse übernommen.</span>
                        </div>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>

        <template
            v-slot:item="data"
        >
            <v-row class="no-frame pt-1 pb-1" >
                <v-col class="no-frame">
                    <div class="v-flex pl-2" style="font-size: 15px">
                        <div class="pr-2" style="margin-top: -2px;">
                            <v-icon size="18">{{ isPrefered (data.item) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                        </div>

                        <div style="margin-left: -5px;">
                            {{ data.item.company ? data.item.company.name : '---' }}
                        </div>
                    </div>
                    <div style="font-size: 12px; margin-left: 30px;" v-for="(role, index) in data.item.roles" :key="index">
                        {{ role.name }}
                    </div>
                </v-col>
                <v-col class="no-frame">
                    <div style="font-size: 16px">
                        {{ data.item.name }}
                    </div>
                    <div style="font-size: 12px">
                        {{ data.item.email }}
                    </div>
                </v-col>
            </v-row>
        </template>
    </v-combobox>
</template>

<script>
import PRecipientChip from "@/modules/inc/mail/private/PRecipientChip.vue";
import Core from "@/modules/core/service/Core";
export default {
    name: "PIncMailRecipient",

    components: {
        PRecipientChip
    },

    props: {
        value: {

        },

        label: {
            required: true,
        },

        recipients: {
            required: true,
            type    : Array
        },

        chipColor: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        }
    },

    data: () => ({
        selected: [],
        menu    : false,
        favorite: true,
        refresh : 0,
        search  : null
    }),

    mounted() {
        this.selected = this.value
    },

    watch: {
        value: {
            deep: true,
            handler: function () {
                this.selected = this.value
            }
        }
    },

    computed: {
        contacts () {
            const recipients = this.recipients.slice().sort ((l,r) => {
                if (l.prefered && !r.prefered) {
                    return -1
                } else if (!l.prefered && r.prefered) {
                    return 1;
                }

                return l.contact.name.localeCompare (r.contact.name);
            });

            const contacs = [];
            recipients.forEach (r => {
                contacs.push (r.contact);
            });

            return contacs;
        }
    },

    methods: {
        onChange () {
            for (let i=0; i < this.selected.length; i++) {
                const item = this.selected[i];

                if (item.email) {
                    continue;
                }

                const address = item.trim();
                const valid = Core.rule.email(address) === true;
                this.selected[i] = {
                    name: "Neu",
                    email: address,
                    emails: [
                        {
                            address: address,
                            selected: true,
                            valid   : valid
                        }
                    ]
                };
            }

            this.$emit("input", this.selected);
        },

        onRemove (item) {
            let index = null;
            if (item.email) {
                index = this.selected.findIndex(s => s.id === item.id);
            } else {
                index = this.selected.findIndex(s => s === item);
            }

            if (index >= 0) {
                this.selected.splice(index, 1)
            }

            this.$emit("input", this.selected);
        },

        onFavorite () {
            this.favorite = !this.favorite;
            this.refresh ++;
        },

        isPrefered (contact) {
            const c = this.recipients.find (x => x.contact.id === contact.id);
            if (!c) {
                return false;
            }

            return c.prefered;
        }
    }
}
</script>

<style lang="scss" scoped>

.mail-label {
    padding-top: 12px;
    height: 36px;
    width: 80px;
    padding-left: 0;
    border-radius: 2px!important;
    font-size: 15px;
}

.mail-adress {
    padding-top: 0;
}

::v-deep .v-list-item {
    padding-left: 0;
    padding-right: 0;
}

.recipient-mail-input,
.recipient-chip,
.recipient-mail {
    margin-top: 2px;
    width: 190px;
    max-width: 220px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

</style>

